import React from 'react'
import { Flex, Box } from 'reflexbox'
import styles from './FulcrumColor.scss'

const FulcrumColorComponent = (item) => {
  return (
    <Flex justify='flex-start' align='center'>
      <Box class={styles.colorBox} style={item.color}/>
      <Box class={styles.textBox}>
        {item.label}
      </Box>
    </Flex>
  )
}

export default FulcrumColorComponent
